export default __webpack_public_path__ + "static/media/img-0563-finland-full-face.676778be.png";